import React, { Component, PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Tabs, Tab } from 'material-ui/Tabs';
import * as request from 'superagent';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';
import CircularProgress from 'material-ui/CircularProgress';
import AddIcon from 'material-ui/svg-icons/content/add';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { TableRow, TableRowColumn } from "material-ui/Table";
import _ from 'lodash';

import * as DataAPI from "../../../common/DataAPI.js";
import Dialogs from "../../../common/Dialogs.js";
import constants from "../../../common/constants";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";

class DepositDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      amount: '',
    };

    this.updateState = this.updateState.bind(this);
    this.handleInsert = this.handleInsert.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {

  }

  componentWillReceiveProps(newProps) {
    // if (!_.isEqual(newProps.account, this.state.account)) {
    //   this.setState({
    //     account: newProps.account,
    //   });
    // }
  }

  handleInsert() {
    this.props.handleSubmit(this.state.amount);
  }

  handleClose() {
    this.props.handleClose();
  }

  updateState(field, value) {
    this.setState({
      [field]: value,
    });
  }

  render() {
    let actions = [];

    actions.push(<FlatButton
      label="取消"
      primary={true}
      onClick={this.handleClose}
    />);

    actions.push(
      <FlatButton
        label="確定"
        primary={true}
        onClick={this.handleInsert}
      />
    );


    const wrapOnChange = (fnc, field, event, value) => {
      fnc(field, value);
    };

    const wrapSelecFieldtOnChange = (fnc, field, event, index, value) => {
      fnc(field, value);
    };

    return (
      <div>
        <Dialog
          title="存款"
          actions={actions}
          modal={false}
          open={this.props.open}
          autoScrollBodyContent={true}
          // autoDetectWindowHeight={false}
          bodyClassName="deposit-dialog"
          // actionsContainerClassName="account-actions-block"
        >
          <div>
            <TextField
              floatingLabelText="金額"
              name="amount"
              value={this.state.amount}
              onChange={wrapOnChange.bind(this, this.updateState, 'amount')}
              fullWidth={true}
              type="text"
            />
          </div>
        </Dialog>
      </div>
    )
  }
}

DepositDialog.propTypes = {
  open: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
};

DepositDialog.defaultProps = {
  open: false,
  handleSubmit: () => {
  },
  handleClose: () => {
  },
};

export default DepositDialog;


// WEBPACK FOOTER //
// client/adminPanel/panel/accounts/DepositDialog.js